import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class Team_NL extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Fragment>
                <path
                    className={ classes.root }
                    d="M21.61,8.06a3.7,3.7,0,0,1,2.73-.63V8.58a3.09,3.09,0,0,0-2,.44,2.31,2.31,0,0,0-.65,3.34,2.4,2.4,0,0,0,3.4.81,3.05,3.05,0,0,0,1.22-1.88l1.08.4a3.81,3.81,0,0,1-1.7,2.5,3.57,3.57,0,0,1-5.1-1.08A3.58,3.58,0,0,1,21.61,8.06Z"
                />,
                < path
                    className = { classes.root }
                    d = "M28.63,6.48a2.68,2.68,0,1,1,2.25,4.85,2.68,2.68,0,1,1-2.25-4.85Zm1.8,3.87a1.52,1.52,0,0,0,.7-2.08,1.52,1.52,0,1,0-2.75,1.27A1.52,1.52,0,0,0,30.43,10.35Z"
                />,
                < path
                    className = { classes.root }
                    d = "M32.66,4.9l1.16-.35.17.56a2.89,2.89,0,0,1,.09.34h0a2,2,0,0,1,1.42-1.54c1.08-.33,1.86,0,2.26,1.34l.95,3.13-1.2.37-.88-2.89c-.18-.59-.46-1-1.08-.76a1.42,1.42,0,0,0-1,1.4,2.29,2.29,0,0,0,.11.67l.69,2.24-1.22.37Z"
                />,
                < path
                    className = { classes.root }
                    d = "M39.71,6.65A2.17,2.17,0,0,0,41.18,7c.36-.07.63-.28.58-.57-.14-.75-2.56-.21-2.85-1.83-.17-.93.57-1.63,1.66-1.82A2.44,2.44,0,0,1,42.35,3l-.3,1a2,2,0,0,0-1.3-.22c-.33.06-.62.26-.56.57.13.71,2.55.18,2.84,1.8C43.18,7,42.57,7.8,41.38,8a2.87,2.87,0,0,1-2.08-.39Z"
                />,
                < path
                    className = { classes.root }
                    d = "M44.06,3.46l-.66.06-.08-1L44,2.45,43.88,1l1.23-.1.13,1.46,1.15-.1.09,1-1.16.1.17,2a.91.91,0,0,0,1.09.87,1,1,0,0,0,.23,0l.09,1.11a2.18,2.18,0,0,1-.38.06,1.87,1.87,0,0,1-2.28-1.73Z"
                />,
                < path
                    className = { classes.root }
                    d = "M47.77,2.12H49V3a3.47,3.47,0,0,1,0,.36h0A1.77,1.77,0,0,1,50.6,2a1.45,1.45,0,0,1,.23,0V3.3a2.19,2.19,0,0,0-.3,0,1.46,1.46,0,0,0-1.38,1.08,2.74,2.74,0,0,0-.1.83v2H47.8Z"
                />,
                < path
                    className = { classes.root }
                    d = "M52,2.13l1.26.14-.32,3c-.07.62.05,1.05.67,1.12.92.1,1.51-.65,1.61-1.56L55.5,2.5l1.26.14-.54,5.07L55,7.58,55.07,7c0-.2,0-.36,0-.36h0a2,2,0,0,1-1.87.86c-1.08-.11-1.7-.73-1.55-2.12Z"
                />,
                < path
                    className = { classes.root }
                    d = "M61,3.43a2.61,2.61,0,0,1,1.73,1.2l-.75.71a2,2,0,0,0-1.16-.85,1.53,1.53,0,0,0-1.88,1.18A1.56,1.56,0,0,0,60.06,7.6a2.32,2.32,0,0,0,1.61-.29l.27,1a2.9,2.9,0,0,1-2.24.32,2.61,2.61,0,0,1-2.06-3.24A2.63,2.63,0,0,1,61,3.43Z"
                />,
                < path
                    className = { classes.root }
                    d = "M64,5.57l-.62-.22.34-.95.65.23.48-1.39,1.17.41L65.58,5l1.09.38-.33,1L65.24,6l-.65,1.86a.91.91,0,0,0,.63,1.25,1.33,1.33,0,0,0,.22.05l-.36,1a2.15,2.15,0,0,1-.38-.1,1.86,1.86,0,0,1-1.36-2.51Z"
                />,
                < path
                    className = { classes.root }
                    d = "M68,5.87l1.17.51-2,4.67-1.17-.5ZM68.76,4l1.15.5-.45,1-1.15-.51Z"
                />,
                < path
                    className = { classes.root }
                    d = "M72.73,8.05a2.2,2.2,0,0,1,.82,3.21c-.07.13-.26.41-.26.41L70.2,10a1.45,1.45,0,0,0,.7,1.92,2.5,2.5,0,0,0,1.55.21v1a3.21,3.21,0,0,1-2.15-.35,2.6,2.6,0,0,1-1.12-3.66A2.52,2.52,0,0,1,72.73,8.05Zm-.12,2.26a1,1,0,0,0-.37-1.42,1.18,1.18,0,0,0-1.58.35Z"
                />,
                < path
                    className = { classes.root }
                    d = "M75.41,11.07l-.52-.35.57-.84.52.36.13-.19a1.83,1.83,0,0,1,2.78-.39,2.57,2.57,0,0,1,.34.27l-.61.89a1.44,1.44,0,0,0-.2-.16.84.84,0,0,0-1.28.13L77,11l.9.61-.57.83-.9-.61L74.2,15.1l-1-.72Z"
                />,
                < path
                    className = { classes.root }
                    d = "M89.73,33.12,95,34.6a4.6,4.6,0,0,1,.78.28h0s-.09-.19-.2-.5l-1-2.81,1-.37,1.69,4.85-.77.27L91.3,34.84a4.6,4.6,0,0,1-.78-.28h0a4.51,4.51,0,0,1,.2.5l1,3-1,.37-1.76-5Z"
                />,
                < path
                    className = { classes.root }
                    d = "M94.58,41.23l0,.17.07,0c.65-.13.79-.59.68-1.14A2.76,2.76,0,0,0,94.59,39l.79-.66a3.48,3.48,0,0,1,1,1.83,1.89,1.89,0,0,1-1.55,2.49l-3.12.66-.24-1.14.41-.09.36-.06v0a1.64,1.64,0,0,1-1.2-1.33,1.6,1.6,0,0,1,1.2-2C93.85,38.3,94.41,40.42,94.58,41.23Zm-2.48-.47a1.3,1.3,0,0,0,1.54.85l.12,0,0-.22c-.14-.63-.44-1.64-1.14-1.5A.68.68,0,0,0,92.1,40.76Z"
                />,
                < path
                    className = { classes.root }
                    d = "M99,43.78,99.09,45l-3.79.33.06.63,1.9,1.07.12,1.4L95,47.07h0l-2.63,2-.13-1.46,2.1-1.54-.05-.66-2.23.2-.11-1.27Z"
                />,
                < path
                    className = { classes.root }
                    d = "M97.45,52A2.21,2.21,0,0,1,95,54.2c-.15,0-.49,0-.49,0l.11-3.52a1.45,1.45,0,0,0-1.4,1.49,2.51,2.51,0,0,0,.52,1.48l-.93.47A3.27,3.27,0,0,1,92.1,52a2.62,2.62,0,0,1,2.76-2.65A2.52,2.52,0,0,1,97.45,52Zm-2.07.91a1,1,0,0,0,1.09-1,1.19,1.19,0,0,0-1-1.25Z"
                />,
                < path
                    className = { classes.root }
                    d = "M99.06,55.85,98.9,57.1l-5.27-.66c-.56-.07-.72.1-.76.43,0,.1,0,.19,0,.19l-1.11-.14s0-.19,0-.4c.09-.7.38-1.54,1.82-1.36Z"
                />,
                < path
                    className = { classes.root }
                    d = "M96.64,58.67l-.23,1.25-5-.94.23-1.24Zm2,.37-.23,1.23-1.11-.2.23-1.24Z"
                />,
                < path
                    className = { classes.root }
                    d = "M95.77,62.73l-5.1-1.27a1.87,1.87,0,0,1-1.35-2.53,2.88,2.88,0,0,1,.12-.37l1,.26a1,1,0,0,0-.07.21.91.91,0,0,0,.66,1.23l5,1.24ZM98,62l-.3,1.22-1.1-.27.31-1.22Z"
                />,
                < path
                    className = { classes.root }
                    d = "M97.23,65l-.42,1.2L93.23,65l-.21.6,1.3,1.75-.47,1.33L92.23,66.4h0L89,67.18l.48-1.37L92,65.26l.21-.62-2.1-.73.42-1.2Z"
                />,
                < path
                    className = { classes.root }
                    d = "M6.58,77.23,5.23,74.85a2.19,2.19,0,0,1,.9-3.11,2.2,2.2,0,0,1,3.15.82L10,73.82l2.13-1.21.64,1.12Zm1.84-3.91a1.12,1.12,0,0,0-1.65-.44,1.1,1.1,0,0,0-.46,1.61l.6,1.07L9,74.37Z"
                />,
                < path
                    className = { classes.root }
                    d = "M4.34,68.6a2.2,2.2,0,0,1,1.39-3c.14-.06.46-.16.46-.16l1.33,3.26a1.44,1.44,0,0,0,.67-1.92,2.52,2.52,0,0,0-1.07-1.15l.66-.8a3.2,3.2,0,0,1,1.45,1.63A2.62,2.62,0,0,1,7.79,70,2.52,2.52,0,0,1,4.34,68.6Zm1.52-1.68a1,1,0,0,0-.6,1.34A1.19,1.19,0,0,0,6.7,69Z"
                />,
                < path
                    className = { classes.root }
                    d = "M3.19,65.11l-.34-1.17.85-.25.35-.08v0A1.76,1.76,0,0,1,2.33,62.4a1.7,1.7,0,0,1,0-.23l1.2-.34a2.21,2.21,0,0,0,.07.29,1.44,1.44,0,0,0,1.41,1A2.51,2.51,0,0,0,5.8,63l1.94-.56.35,1.22Z"
                />,
                < path
                    className = { classes.root }
                    d = "M5.56,60.18a2.15,2.15,0,0,0,.3-1.47c-.07-.35-.29-.63-.58-.57-.75.14-.19,2.56-1.8,2.86-.93.18-1.63-.55-1.84-1.64a2.41,2.41,0,0,1,.26-1.78l1,.28a1.92,1.92,0,0,0-.2,1.31c.06.33.25.62.57.56.71-.14.16-2.56,1.77-2.86.83-.16,1.64.44,1.87,1.63a2.86,2.86,0,0,1-.37,2.08Z"
                />,
                < path
                    className = { classes.root }
                    d = "M.93,53.74a2.67,2.67,0,1,1,2.85,2.61A2.68,2.68,0,0,1,.93,53.74Zm4.25-.31A1.51,1.51,0,0,0,3.49,52a1.52,1.52,0,1,0,.2,3A1.53,1.53,0,0,0,5.18,53.43Z"
                />,
                < path
                    className = { classes.root }
                    d = "M.92,47a2.67,2.67,0,1,1,5.33.35A2.67,2.67,0,1,1,.92,47Zm4.25.27a1.51,1.51,0,0,0-1.48-1.61,1.52,1.52,0,1,0-.21,3A1.52,1.52,0,0,0,5.17,47.27Z"
                />,
                < path
                    className = { classes.root }
                    d = "M1.46,42.7l.25-1.2.58.12.34.09v0a2,2,0,0,1-.67-2c.23-1.11.94-1.62,2.26-1.34L7.43,39l-.25,1.24-3-.62c-.61-.12-1,0-1.19.59a1.42,1.42,0,0,0,.75,1.55,2.21,2.21,0,0,0,.64.23l2.3.47-.26,1.24Z"
                />,
                < path
                    className = { classes.root }
                    d = "M1,35.86l.37-1.2,5.08,1.59c.53.17.72,0,.82-.28,0-.1,0-.19,0-.19l1.06.34a2.52,2.52,0,0,1-.1.39c-.21.66-.64,1.44-2,1Z"
                />,
                < path
                    className = { classes.root }
                    d = "M2,32.8l.45-1.18,1.06.4L3.09,33.2Zm1.87.71.46-1.19,4.76,1.83-.46,1.18Z"
                />,
                < path
                    className = { classes.root }
                    d = "M3.16,30l.52-1.15,1,.46-.52,1.15Zm2.34-.34,4.79,2.17a1.88,1.88,0,0,1,.87,2.73,2,2,0,0,1-.19.34l-1-.44a1.55,1.55,0,0,0,.11-.19.92.92,0,0,0-.44-1.33L5,30.82Z"
                />,
                < path
                    className = { classes.root }
                    d = "M4.48,27.13,5.11,26l3.3,1.87.31-.54-1-2,.7-1.23,1.19,2.53h0L13,26.5l-.72,1.27-2.6.08-.33.57,1.94,1.1-.62,1.11Z"
                />,
                < path
                    className = { classes.root }
                    d = "M33.78,89.08l1.22.41-.93,2.74.87.29,2.51-2.2,1.33.45-3,2.56v0l.84,4.19-1.38-.47-.65-3.49-.87-.3-1,2.94-1.22-.41Z"
                />,
                < path
                    className = { classes.root }
                    d = "M39,92.8l1.19.26-.18.86c0,.18-.09.34-.09.34h0a1.74,1.74,0,0,1,1.85-1l.22.07-.25,1.22a1.85,1.85,0,0,0-.29-.08,1.45,1.45,0,0,0-1.58.76,2.63,2.63,0,0,0-.28.79l-.42,2L38,97.79Z"
                />,
                < path
                    className = { classes.root }
                    d = "M42.79,93.52l1.26.17-.67,5-1.26-.16Zm.26-2,1.25.16-.15,1.12-1.25-.16Z"
                />,
                < path
                    className = { classes.root }
                    d = "M45.52,94.94l-.66,0,.06-1,.69,0,.08-1.46,1.24.07L46.84,94l1.16.06-.06,1L46.78,95l-.11,2a.9.9,0,0,0,.95,1,.88.88,0,0,0,.23,0l-.07,1.11a2.48,2.48,0,0,1-.39,0,1.87,1.87,0,0,1-2-2.05Z"
                />,
                < path
                    className = { classes.root }
                    d = "M49,92H50.3v1.13H49.05Zm0,2,1.27,0,.07,5.1-1.27,0Z"
                />,
                < path
                    className = { classes.root }
                    d = "M52.13,97.49a2.18,2.18,0,0,0,1.44.43c.36,0,.65-.22.63-.52-.07-.76-2.54-.43-2.69-2.06-.09-1,.71-1.58,1.8-1.68a2.42,2.42,0,0,1,1.76.42l-.38,1a1.89,1.89,0,0,0-1.28-.32c-.33,0-.64.2-.61.52.07.71,2.53.39,2.68,2,.08.84-.59,1.59-1.8,1.7a2.85,2.85,0,0,1-2-.56Z"
                />,
                < path
                    className = { classes.root }
                    d = "M58.35,92.88a2.6,2.6,0,0,1,2.07.34l-.36,1a2,2,0,0,0-1.42-.27,1.51,1.51,0,0,0-1.19,1.86A1.55,1.55,0,0,0,59.33,97a2.35,2.35,0,0,0,1.34-.94l.66.78a2.93,2.93,0,0,1-1.89,1.24,2.67,2.67,0,1,1-1.09-5.22Z"
                />,
                < path
                    className = { classes.root }
                    d = "M60.55,90.45l1.2-.42.82,2.32a4.09,4.09,0,0,1,.12.41h0A2,2,0,0,1,64,91.21c1.07-.37,1.87,0,2.32,1.24l1.09,3.1L66.25,96l-1-2.85c-.21-.59-.5-.93-1.11-.71a1.42,1.42,0,0,0-1,1.46,2.24,2.24,0,0,0,.14.64l.78,2.21-1.2.42Z"
                />
            </Fragment>
        );
    }
}
export default Team_NL;

Team_NL.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string
    })
};

Team_NL.defaultProps = {
    classes: {}
};
